module.exports = __webpack_public_path__ + "img/jb_t3411_22-1999.prt.7b3de4e5.jpg";